import type { ReactNode } from 'react';
import AffiliateLogos from './AffiliateLogos';
import SignupProgress, { type SignupFlowStep } from './SignupProgress';
import { CompanyLogo } from '@/Components/shared';
import UIStrings from '@/Utils/UIStrings';

export type { SignupFlowStep };

interface SignupFlowLayoutProps {
    currentStep: SignupFlowStep;
    children: ReactNode;
}

function SignupFlowLayout({ currentStep, children }: SignupFlowLayoutProps) {
    return (
        <div className="bg-background grid min-h-svh lg:h-svh lg:grid-cols-[minmax(0,1.1fr)_minmax(280px,0.9fr)] xl:grid-cols-[minmax(0,1fr)_minmax(420px,720px)]">
            <section className="flex flex-col px-4 py-5 sm:px-10 lg:overflow-y-auto lg:px-14 lg:py-8">
                <header className="shrink-0">
                    <a
                        href="https://www.talentmesh.com"
                        className="focus-visible:outline-primary inline-flex w-33 rounded-sm focus-visible:outline-2 focus-visible:outline-offset-[3px]"
                        aria-label={UIStrings.CompanyLogo}
                    >
                        <CompanyLogo width={132} height={25} color="primary" aria-hidden />
                    </a>
                </header>
                <div className="mx-auto flex w-full max-w-110 flex-col py-7 lg:flex-1 lg:justify-center lg:py-6">
                    {children}
                </div>
                <AffiliateLogos />
            </section>
            <SignupProgress currentStep={currentStep} />
        </div>
    );
}

export default SignupFlowLayout;
